module.exports = __webpack_public_path__ + "img/edge_activites_artisanat_dart.b09891fd.svg";